import { render, staticRenderFns } from "./BasePhone.vue?vue&type=template&id=2ed62006&"
import script from "./BasePhone.vue?vue&type=script&lang=js&"
export * from "./BasePhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports